import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";

import "./modal.css";

const ConfirmationModal = ({
  isOpen,
  message = "Are you sure?",
  onClose,
  onSubmit,
}) => {
  const [loading, setLoading] = useState(false);

  // prevent background scroll
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  // ESC key support
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape" && !loading) {
        onClose();
      }
    };

    if (isOpen) {
      window.addEventListener("keydown", handleEsc);
    }

    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [isOpen, loading]);

  if (!isOpen) return null;

  const handleSubmit = async () => {
    if (loading) return;

    try {
      setLoading(true);

      await onSubmit();

      // 👉 replace with your alert lib
      window.alert("Success!");

      onClose();
    } catch (err) {
      console.error(err);

      window.alert(err?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleOverlayClick = () => {
    if (loading) return;
    onClose();
  };

  const modalContent = (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div
        className="modal-box"
        onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
      >
        <p className="modal-message">{message}</p>

        <div className="modal-actions">
          <button
            className="modal-btn cancel"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>

          <button
            className="modal-btn confirm"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Processing..." : "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default ConfirmationModal;